/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ReportIdTitleReferenceTitle } from './reportIdTitleReferenceTitle';

/**
 * Reference to any item in a report just by id and title
 */
export interface ReportIdTitleReference {
  id: string;
  title?: ReportIdTitleReferenceTitle;
}
